<template>
  <v-container class="align-center justify-center"
               fluid style="height: 100%">
    <v-card flat style="background: transparent">
      <v-card-text style="padding: 0">
        <v-form v-model="valid">
          <div>
            <p>{{ $t('NIE/NIF') }}</p>
            <v-text-field
              id="cif"
              v-model="cif"
              outlined
              name="cif"
              type="text"
              :rules="rules.cif"
              @keyup.enter="onSubmit('keyboard')"
            />
          </div>
          <div align="center">
            <p>{{ $t('Password') }}</p>
            <v-text-field
              id="password"
              v-model="password"
              outlined
              name="password"
              type="password"
              :rules="rules.password"
              required
              @keyup.enter="onSubmit('keyboard')"
            />
          </div>
        </v-form>
      </v-card-text>
      <div class="text-decoration-underline" align="center" style="padding-top: 5px;padding-bottom: 10px; cursor: pointer; color: dodgerblue; position: relative">
        <span class="text-decoration-underline" style="cursor: pointer; color: white" @click="showResetPass()">{{ $t('Login.Forgot Password?') }}</span>
      </div>
      <v-card-actions class="text-center" style="padding: 0px">
        <v-container style="padding: 0px">
          <v-row dense>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <div align="center">
                <v-btn class="btn-white" @click="onSubmit">
                  {{ $t('LOG IN') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="$user && !$user.registered" justify="center">
            <v-btn color="red" style="margin-top: 25px" dark depressed x-large @click="doLogout">
              {{ $t('Login.LogoutUnregisteredUser') }}
            </v-btn>
          </v-row>
        </v-container>
      </v-card-actions><br>
      <div align="center" style="padding-top: 15px;color: white">
        <span>{{ $t('Login.New to Byppay?') }}</span>
      </div>
      <div align="center">
        <span class="white-text-underline" @click="goToRegister()">{{ $t('Sign Up') }}</span>
      </div>
      <v-btn class="btn-white" style="margin-top: 25px" @click="goToLanding">
        {{ $t('Login.about') }}
      </v-btn>
    </v-card>
  </v-container>
</template>

<script >
import AuthRepository from "../repositories/AuthRepository";
import LocalRepository from "../repositories/LocalRepository";
import Constants from "../../constants";
import LoginGoogle from "../components/LoginGoogle";
import LoginFacebook from "../components/LoginFacebook";

export default {
    name: 'Login',
    components: { },
    props: {
        source: { type: String, default: null },
    },
    data () {
        return {
            emailReset: "",
            error: false,
            errorMsg: "",
            cif: null,
            password: "",
            token: "",
            newPass: "",
            newPassConfirmation: "",
            resetToken: "",
            valid: false,
            emailComp: null,
            resetPass: false,
            mostrarResetPass: false,
            rules: {
                cif: [
                    val => (val || '').length > 0 || 'This field is required'
                ],
                password: [
                    val => (val || '').length > 0 || 'This field is required'
                ]
            },
            googleSignInParams: {
                client_id: 'AIzaSyAjwTF-cpLA81M8YUSvJty1B7Y0qp7NCH8'
            }
        };
    },
    watch: {
        $route () {
            this.token = this.$route.query.token;
            if (this.token !== undefined) {
                this.validateUser(this.token);
            }
            this.resetToken = this.$route.query.resetToken;
            if (this.resetToken !== undefined) {
                this.resetPass = false;
                this.mostrarResetPass = true;
            }
        }
    },
    mounted () {
        if (this.$route.params.color && this.$route.params.message) {
            this.$root.$emit('show-snackbar', {message: this.$route.params.message, color: this.$route.params.color});
        }
    },
    created () {
        this.$root.$on('log-google', (response) => {
            this.loadMain(response);
        });
        this.$root.$on('log-facebook', (response) => {
            this.loadMain(response);
        });
        const cifLoginRepository = LocalRepository.get('cif-user-compensation');
        if (cifLoginRepository) {
            this.cif = cifLoginRepository;
        }
        const emailLoginUser = localStorage.getItem('email-user-compensation');
        if (emailLoginUser) {
            this.emailComp = emailLoginUser;
        }
        this.token = this.$route.query.token;
        this.resetToken = this.$route.query.resetToken;

        const tokenLogin = LocalRepository.get('token');
        if (tokenLogin && this.$user && this.$user.registered) {
            this.$router.push({name: 'root', replace: true}).catch(() => {
            });
        } else if (this.token !== undefined) {
            this.validateUser(this.token);
        }
        if (this.resetToken !== undefined) {
            this.resetPass = false;
            this.mostrarResetPass = true;
        }
    },
    methods: {
        // onSubmit () {
        //     if (!this.$data.cif) {
        //         // TODO notify empty value
        //     }
        //     AuthRepository.login(this.$data.cif)
        //         .then((response) => {
        //             if (response && response.data && response.data.token) {
        //                 LocalRepository.set('token', response.data.token);
        //                 this.$router.push({name: 'root', replace: true});
        //             }
        //             // TODO notify error
        //         })
        //         .catch(() => {
        //             // TODO notify error
        //         });
        // },

        doLogout () {
            LocalRepository.clear('token');
            this.$root.$emit('show-snackbar', {message: this.$t('Login.Logged out succesfully!'), color: "success"});
            location.reload();
        },

        showResetPass () {
            this.resetPass = true;
        },
        validateUser (token) {
            console.log(token);
            AuthRepository.validate(token)
                .then((response) => {
                    if (response && response.data && response.data.token) {
                        this.$root.$emit('show-snackbar', {message: response.data.msg, color: "success"});
                        this.cif = response.data.cif;
                    }
                })
                .catch((err) => {
                    let missatge = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_USER_NOT_FOUND) {
                        missatge = this.$t('Login.ERROR: Invalid token, check again the URL on your e-mail');
                    } else if ( err.response.data.errorCode === Constants.ERRORS.ERROR_USER_ALREADY_VALIDATED) {
                        missatge = this.$t('Login.ERROR: You are already validated');
                    }
                    this.$root.$emit('show-snackbar', {message: missatge, color: "error"});
                })
                .finally(() => {
                    //console.log("END");
                });
        },
        onSubmit () {
            if (!this.cif || !this.password) {
                this.$root.$emit('show-snackbar', {message: this.$t('Login.You let empty params, check it again please'), color: "error"});
            }
            AuthRepository.login(this.cif, this.password)
                .then((response) => {
                    this.loadMain(response);
                    this.$router.push({name: 'InvoiceChats', replace: false});
                    this.$root.$emit('show-snackbar', {message: this.$t('Login.Logged successfully!'), color: "success"});
                })
                .catch((err) => {
                    console.log(err);
                    let message = "";
                    if (err.response.data) {
                        if (err.response.data.errorCode === Constants.ERRORS.ERROR_MISSING_FIELDS) {
                            message = this.$t('Login.ERROR: Missing fields on the formulary');
                        } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_USER_NOT_FOUND) {
                            message = this.$t('Login.ERROR: User not found');
                        } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_WRONG_PASSWORD) {
                            message = this.$t('Login.ERROR: Wrong password');
                        } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_MISSING_VALIDATION) {
                            message = this.$t('Login.ERROR: User is not validated');
                        } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_GENERIC) {
                            message = this.$t('ERROR: Something went wrong');
                        }
                    } else {
                        message = err.message;
                    }
                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                });
        },
        loadMain (response) {
            if (response && response.data && response.data.token) {
                const connectionSocket = LocalRepository.get('connectionSocket');
                LocalRepository.set('token', response.data.token);
                if (connectionSocket) {
                    AuthRepository.saveSocket(connectionSocket).then(() => {}).finally(() => {
                        this.$root.$emit('check-user-cif', response.data.userId);
                        this.$root.$emit('show-splash-check', response.data.userCif);
                        this.$router.push({name: 'root', replace: true}).catch(() => {});
                    });
                } else {
                    this.$root.$emit('check-user-cif', response.data.userId);
                    this.$root.$emit('show-splash-check', response.data.userCif);
                    this.$router.push({name: 'root', replace: true}).catch(() => {});
                }
                //
            } else {
                this.$root.$emit('show-snackbar', {message: this.$t('ERROR: Something went wrong'), color: "error"});
            }
        },
        goRegister () {
            if (this.$router.history.current.name !== "register") {
                this.$router.push("register");
            }
        },
        goToLanding () {
            window.location.replace(Constants.LANDING_BASE_URL);
        },
        authenticate: function (provider) {
            this.$auth.authenticate(provider).then(() => {
                // Execute application logic after successful social authentication
            });
        },
        reset () {
            this.error = false;
            AuthRepository.resetPass(this.emailReset)
                .then(response => {
                    if (response) {
                        this.emailReset = "";
                        this.mostrarMiss = false;
                        this.resetPass = false;
                        this.$root.$emit('show-snackbar', {message: this.$t('Login.Check your email in order to reset the password')});
                    }
                })
                .catch((err) => {
                    this.error = true;
                    this.$root.$emit('show-snackbar', {message: this.$t('Login.Error: Cannot send an email to reset you password. Please check the email you enter.'), color: "error"});
                    console.log(err);
                })
                .finally(() => {
                });
        },
        changePassword () {
            this.error = false;
            if ( this.newPass === this.newPassConfirmation) {
                AuthRepository.changePass(this.newPass, this.resetToken)
                    .then(response => {
                        if (response) {
                            this.newPass = "";
                            this.newPassConfirmation = "";
                            this.mostrarResetPass = false;
                            this.mostrarMiss = false;
                            this.resetPass = false;
                            this.$root.$emit('show-snackbar', {message: this.$t('Login.You can now log in')});
                        }
                    }).catch((err) => {
                        this.$root.$emit('show-snackbar', {message: this.$t('Login.Error: Cannot find the current user. Please, try again later.'), color: "error"});
                        console.log(err);
                    }).finally(() => {  });
            } else {
                this.$root.$emit('show-snackbar', {message: this.$t('Login.Passwords doesn\'t match'), color: "error"});
            }
        },
        goToRegister () {
            this.$router.push({name: 'Register', replace: true});
        }
    }
};
</script>
<style >
  .v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    height: 40px;
  }
  .right /deep/ input::placeholder {
    text-align: center;
  }
  .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 4px !important;
  }
  .v-input__slot {
    margin-bottom: 4px !important;
    height: 30px;
  }
  html,body {
    margin:    0 auto;
    height: 100%;
  }
  body {
    width: 100%;
    height: 100%;
    position: fixed;
  }

</style>
